export const ar: Record<string, string> = {
  'widget.title': 'الدعم',
  'widget.newTicket': 'تذكرة جديدة',
  'widget.trackTicket': 'تتبع التذكرة',
  'form.title': 'العنوان',
  'form.titlePlaceholder': 'ملخص موجز لمشكلتك',
  'form.description': 'الوصف',
  'form.descriptionPlaceholder': 'صف مشكلتك بالتفصيل...',
  'form.email': 'البريد الإلكتروني',
  'form.emailPlaceholder': 'your@email.com',
  'form.priority': 'الأولوية',
  'form.priorityLow': 'منخفضة',
  'form.priorityMedium': 'متوسطة',
  'form.priorityHigh': 'عالية',
  'form.priorityCritical': 'حرجة',
  // Deprecated alias kept so existing host translations overriding this key keep working.
  'form.priorityUrgent': 'حرجة',
  'form.category': 'الفئة',
  'form.categoryNone': 'اختر فئة',
  'form.submit': 'إرسال التذكرة',
  'form.submitting': 'جارِ الإرسال...',
  'form.cancel': 'إلغاء',
  'form.attachment': 'إرفاق ملفات',
  'success.title': 'تم إرسال التذكرة!',
  'success.ticketNumber': 'تذكرة #',
  'success.trackingToken': 'رمز التتبع الخاص بك:',
  'success.trackingHint': 'احفظ هذا الرمز لتتبع حالة تذكرتك.',
  'success.copyToken': 'نسخ الرمز',
  'success.copied': 'تم النسخ!',
  'success.close': 'إغلاق',
  'success.trackNow': 'تتبع التذكرة',
  'tracker.title': 'تتبع تذكرتك',
  'tracker.tokenPlaceholder': 'أدخل رمز التتبع الخاص بك (trk_...)',
  'tracker.submit': 'تتبع',
  'tracker.tracking': 'جارِ التتبع...',
  'tracker.status': 'الحالة',
  'tracker.priority': 'الأولوية',
  'tracker.created': 'تاريخ الإنشاء',
  'tracker.replies': 'الردود',
  'tracker.noReplies': 'لا توجد ردود بعد.',
  'tracker.replyPlaceholder': 'اكتب رداً...',
  'tracker.sendReply': 'إرسال الرد',
  'tracker.sending': 'جارِ الإرسال...',
  'tracker.back': 'رجوع',
  'tracker.staff': 'فريق الدعم',
  'error.generic': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'error.validation': 'يرجى تصحيح الحقول المميزة والمحاولة مرة أخرى.',
  'error.network': 'خطأ في الشبكة. تحقق من اتصالك.',
  'error.server': 'الخادم يواجه مشكلة. يرجى المحاولة بعد قليل.',
  'error.forbidden': 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
  'error.unauthenticated': 'يرجى تسجيل الدخول للمتابعة.',
  'error.notFound': 'تعذّر العثور على ما تبحث عنه.',
  'notification.dismiss': 'إغلاق',
  'error.tokenInvalid': 'رمز التتبع غير صالح أو منتهي الصلاحية.',
  'error.required': 'هذا الحقل مطلوب.',
  'error.emailInvalid': 'يرجى إدخال بريد إلكتروني صالح.',
  'error.titleMin': 'يجب أن يكون العنوان 5 أحرف على الأقل.',
  'portal.title': 'بوابة الدعم',
  'portal.myTickets': 'تذاكري',
  'portal.noTickets': 'لا توجد تذاكر بعد.',
  'portal.newTicket': 'تذكرة جديدة',
  'widget.close': 'إغلاق',
  'menu.newTicket': 'إرسال تذكرة',
  'menu.newTicketDesc': 'إنشاء طلب دعم جديد',
  'menu.myTickets': 'تذاكري',
  'menu.myTicketsDesc': 'عرض وإدارة تذاكرك',
  'menu.trackTicket': 'تتبع تذكرة',
  'menu.trackTicketDesc': 'تحقق من الحالة باستخدام رمز التتبع',
  'menu.knowledgeBase': 'قاعدة المعرفة',
  'menu.knowledgeBaseDesc': 'تصفح مقالات المساعدة والأدلة',
  'menu.myTicketsPlaceholder': 'سجّل الدخول لعرض تذاكرك.',
  'menu.trackPlaceholder': 'تتبع التذاكر قريبًا.',
  'menu.kbPlaceholder': 'قاعدة المعرفة قريبًا.',
  'menu.preferences': 'التفضيلات',
  'menu.preferencesDesc': 'إعدادات اللغة والمظهر',
  'prefs.title': 'التفضيلات',
  'prefs.language': 'اللغة',
  'prefs.theme': 'المظهر',
  'prefs.light': 'فاتح',
  'prefs.dark': 'داكن',
  'prefs.auto': 'النظام',
  'branding.poweredBy': 'مدعوم من',
  'attach.dropzone': 'اسحب الملفات هنا أو انقر للتصفح',
  'attach.dropzoneActive': 'أفلت الملفات هنا',
  'attach.maxFiles': 'بحد أقصى {max} ملفات',
  'attach.remove': 'إزالة',
  'attach.uploading': 'جارِ رفع الملفات...',
  'attach.uploadProgress': 'جارِ رفع {name}... {percent}%',
  'attach.invalidType': 'نوع الملف غير مسموح',
  'attach.tooLarge': 'حجم الملف يتجاوز الحد الأقصى',
  'attach.tooMany': 'تم الوصول للحد الأقصى لعدد الملفات',
  'attach.download': 'تحميل',
  'mytickets.title': 'تذاكري',
  'mytickets.emailPrompt': 'أدخل بريدك الإلكتروني لعرض تذاكرك',
  'mytickets.emailPlaceholder': 'your@email.com',
  'mytickets.rememberMe': 'تذكرني',
  'mytickets.lookup': 'البحث عن تذاكري',
  'mytickets.lookingUp': 'جارِ البحث...',
  'mytickets.noTickets': 'لا توجد تذاكر بعد.',
  'mytickets.submitFirst': 'أرسل تذكرتك الأولى',
  'mytickets.noAccount': 'لم يتم العثور على تذاكر لهذا البريد.',
  'detail.description': 'الوصف',
  'detail.attachments': 'المرفقات',
  'detail.noAttachments': 'لا توجد مرفقات',
  'detail.replies': 'المحادثة',
  'detail.noReplies': 'لا توجد ردود بعد.',
  'detail.replyPlaceholder': 'اكتب رداً...',
  'detail.sendReply': 'إرسال',
  'detail.sending': 'جارِ الإرسال...',
  'detail.replyAttachLabel': 'إرفاق ملفات بهذا الرد',
  'detail.replyAttachHint': 'إرفاق ملفات',
  'detail.staff': 'فريق الدعم',
  'detail.you': 'أنت',
  'detail.loading': 'جارِ تحميل التذكرة...',
  'track.title': 'تتبع تذكرة',
  'track.tokenPlaceholder': 'أدخل رمز التتبع (trk_...)',
  'track.submit': 'تتبع',
  'track.tracking': 'جارِ التتبع...',
  'track.recentTickets': 'التذاكر الأخيرة',
  'track.invalidToken': 'رمز التتبع غير صالح أو منتهي.',
  'prefs.clearEmail': 'مسح البريد المحفوظ',
  'prefs.emailCleared': 'تم مسح البريد',
  'auth.login': 'تسجيل الدخول',
  'auth.logout': 'تسجيل الخروج',
  'auth.sessionExpired': 'انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.',
  'auth.loginRequired': 'يرجى تسجيل الدخول لاختيار مشروع.',
  'auth.noAuthConfigured': 'لم يتم تكوين المصادقة لهذه الأداة.',
  'auth.noAuthConfiguredHint': 'يرجى التواصل مع مالك الموقع لتفعيل خيار تسجيل دخول واحد على الأقل.',
  'widget.expand': 'توسيع',
  'widget.collapse': 'تصغير',
  'detail.originalRequest': 'الطلب الأصلي',
  'detail.status': 'الحالة',
  'detail.priority': 'الأولوية',
  'detail.created': 'تاريخ الإنشاء',
  'detail.reference': 'المرجع',
  'prefs.accentColor': 'لون التمييز',
  'prefs.position': 'موضع الأداة',
  'prefs.topStart': 'أعلى البداية',
  'prefs.topEnd': 'أعلى النهاية',
  'prefs.bottomStart': 'أسفل البداية',
  'prefs.bottomEnd': 'أسفل النهاية',
  'prefs.displayMode': 'طريقة العرض',
  'prefs.display.popover': 'نافذة منبثقة',
  'prefs.display.side-sheet': 'لوحة جانبية',
  'prefs.display.bottom-sheet': 'لوحة سفلية',
  'prefs.sheetSide': 'الجانب',
  'prefs.side.start': 'البداية',
  'prefs.side.end': 'النهاية',
  'form.categoryPlaceholder': 'اختر فئة',
  'form.categoryBack': 'رجوع',
  'form.categorySelected': 'الفئة',
  'form.tags': 'الوسوم',
  'tag.addNew': 'إضافة وسم',
  'tag.addFirst': 'أضف أول وسم',
  'tag.namePlaceholder': 'اسم الوسم الجديد',
  'tag.exists': 'يوجد وسم بهذا الاسم بالفعل.',
  'diag.title': 'مشاركة معلومات التشخيص',
  'diag.shareAll': 'مشاركة معلومات التشخيص مع الدعم',
  'diag.hint': 'ساعدنا في حل مشكلتك بشكل أسرع — لا شيء حساس',
  'diag.showIncluded': 'عرض المعلومات المضمّنة',
  'diag.hideIncluded': 'إخفاء المعلومات المضمّنة',
  'diag.screenResolution': 'دقة الشاشة',
  'diag.deviceType': 'نوع الجهاز',
  'diag.timezone': 'المنطقة الزمنية',
  'diag.referrerUrl': 'رابط المصدر',
  'diag.language': 'لغة المتصفح',
  'diag.platform': 'المنصة',
  'detail.resolve': 'تحديد كمحلول',
  'detail.resolving': 'جارِ الحل...',
  'detail.resolved': 'محلول',
  'detail.sla': 'اتفاقية الخدمة',
  'category.addNew': 'إضافة فئة',
  'category.addUnder': 'ضمن',
  'category.namePlaceholder': 'اسم الفئة',
  'form.categorySearch': 'بحث في الفئات',
  'form.categoryRoot': 'الكل',
  'form.categoryNoMatch': 'لا توجد فئات مطابقة لبحثك.',
  'form.categoryLeaf': 'لا توجد فئات فرعية هنا.',
  'form.categoryClear': 'مسح',
  'category.exists': 'هذه الفئة موجودة بالفعل',
  'category.limitReached': 'تم الوصول لحد الفئات — قم بترقية خطتك',
  'project.select': 'اختر المشروع',
  'project.switch': 'تبديل المشروع',
  'project.switchDesc': 'تغيير المشروع النشط',
  'project.loading': 'جاري تحميل المشاريع...',
  'project.noProjects': 'لا توجد مشاريع متاحة',
  'project.current': 'المشروع الحالي',
  'prefs.resetToDefaults': 'إعادة إلى الافتراضي',
  'prefs.resetConfirm': 'إعادة تعيين جميع التفضيلات إلى افتراضيات المستضيف؟',
}
